<div class="shadowBorder">
   <div class="cards">
      <div class="shadowBorder">
         <img src="../../../../../../assets/images/newIcons/6.Thesis_Color.png" alt="" />
         <div>
            Total theses
            <span>
               {{
                  thesisOverviewStatistics?.bachelorThesis +
                     thesisOverviewStatistics?.masterThesis +
                     thesisOverviewStatistics?.phdThesis
               }}
            </span>
         </div>
      </div>
      <div class="shadowBorder">
         <img src="../../../../../../assets/images/newIcons/7.Thesis_Bachelor_Color.png" alt="" />
         <div>
            {{ 'general.bachelor' | translate }}
            <span>{{ thesisOverviewStatistics?.bachelorThesis || 0 }}</span>
         </div>
      </div>
      <div class="shadowBorder">
         <img src="../../../../../../assets/images/newIcons/8.Thesis_Master_Color.png" alt="" />
         <div>
            {{ 'general.master' | translate }}
            <span>{{ thesisOverviewStatistics?.masterThesis || 0 }}</span>
         </div>
      </div>
      <div class="shadowBorder">
         <img src="../../../../../../assets/images/newIcons/9.Thesis_PHD_Color.png" alt="" />
         <div>
            {{ 'general.phd' | translate }}.
            <span>{{ thesisOverviewStatistics?.phdThesis || 0 }}</span>
         </div>
      </div>
   </div>
   <div>
      <h3
         *ngIf="
            !(
               this.thesisSubmissions?.thesisNumber == 0 &&
               level == '-1' &&
               facultyId == '-1' &&
               departmentId == '-1' &&
               professorId == '-1' &&
               studentName == undefined
            )
         "
         class="filtersContainer"
      >
         <h4>{{ 'general.submissions' | translate }}</h4>
         <div class="selectors">
            <div>
               <select [(ngModel)]="facultyId" (change)="selectedFaculty()">
                  <option value="-1" selected disabled>
                     {{ 'app.filter_by_institution' | translate }}
                  </option>
                  <ng-container *ngFor="let faculty of this.faculties">
                     <option value="{{ faculty.id }}">{{ faculty.name }}</option>
                  </ng-container>
                  <option value="">{{ 'general.all' | translate }}</option>
               </select>
            </div>
            <div>
               <select
                  disabled
                  *ngIf="facultyId == '' || facultyId == '-1'"
                  name=""
                  id=""
               >
                  <option value="">{{ 'general.select_institution_first' | translate }}</option>
               </select>
               <select
                  *ngIf="facultyId !== '' && facultyId !== '-1'"
                  [(ngModel)]="departmentId"
                  (change)="filterThesis()"
               >
                  <option value="-1" selected disabled>
                     {{ 'app.filter_by_department' | translate }}
                  </option>
                  <ng-container *ngFor="let department of this.departments">
                     <option value="{{ department.id }}">
                        {{ department.name }}
                     </option>
                  </ng-container>
                  <option value="">{{ 'general.all' | translate }}</option>
               </select>
            </div>
            <div>
               <select [(ngModel)]="professorId" (change)="filterThesis()">
                  <option value="-1" selected disabled>
                     {{ 'app.filter_by_educator' | translate }}
                  </option>
                  <ng-container *ngFor="let professor of this.professors">
                     <option value="{{ professor.id }}">
                        {{ professor.name }}
                     </option>
                  </ng-container>

                  <option value="">{{ 'general.all' | translate }}</option>
               </select>
            </div>
            <div>
               <select [(ngModel)]="level" (change)="filterThesis()">
                  <option value="-1" selected disabled>
                     {{ 'app.filter_by_level' | translate }}
                  </option>
                  <option value="bachelor">Bachelor</option>
                  <option value="master">{{ 'general.master' | translate }}</option>
                  <option value="phd">{{ 'general.phd' | translate }}.</option>
                  <option value="">{{ 'general.all' | translate }}</option>
               </select>
            </div>
            <input
               [placeholder]="'placeholders.search_by_student' | translate"
               [(ngModel)]="studentName"
               (ngModelChange)="studentFilter()"
               type="text"
            />
            <button class="reportBtn" (click)="resetFilter()">{{ 'general.reset' | translate }}</button>
         </div>
      </h3>

      <div
         *ngIf="this.thesisSubmissions?.thesisNumber != 0"
         class="tableWithExpandedInfoThesis"
      >
         <div
            *ngFor="
               let thesis of this.thesisSubmissions?.thesisSubmissionsStatistics
                  | paginate
                     : {
                          itemsPerPage: 5,
                          currentPage: page,
                          totalItems: this.thesisSubmissions?.thesisNumber
                       };
               let i = index
            "
         >
            <div>
               <h4 class="blueText bold">{{ thesis.thesisName }}</h4>
               <div>
                  <div>
                     <span>{{ 'general.student' | translate }}</span>
                     <span>{{ 'app.institution' | translate }}</span>
                     <span>{{ 'general.department' | translate }}</span>
                     <span>{{ 'general.end_date' | translate }}</span>
                     <span>{{ 'general.submissions' | translate }}</span>
                     <span>{{ 'general.language' | translate }}<br/> {{ 'report.similarity' | translate }}</span>
                     <span>Translation language<br/> {{ 'report.similarity' | translate }}</span>
                  </div>
                  <div>
                     <span class="bold">{{ thesis.studentName }}</span>
                     <span class="bold">{{ thesis.facultyName }}</span>
                     <span class="bold">{{ thesis.departmentName }}</span>
                     <span class="bold">{{ thesis.endDate.split('T')[0] }}</span>
                     <span class="bold">{{ thesis.submissionsCount }}</span>
                     <span class="bold" *ngIf="thesis.submissionsCount !== 0"
                     [ngClass]="{
                        'highAverage':
                        thesis.avgMLPag.toFixed(2) > 20,
                        'lowAverage':
                        thesis.avgMLPag.toFixed(2) >= 0 &&
                        thesis.avgMLPag.toFixed(2) < 5,
                        'mediumAverage':
                        thesis.avgMLPag.toFixed(2) >= 5 &&
                        thesis.avgMLPag.toFixed(2) <= 20
                     }">{{ thesis.avgMLPag.toFixed(2) }}</span>
                     <span *ngIf="thesis.submissionsCount == 0">
                        -
                     </span>
                     <span   *ngIf="thesis.submissionsCount !== 0"     [ngClass]="{
                        'highAverage':
                        thesis.avgCrossplag.toFixed(2) > 20,
                        'lowAverage':
                        thesis.avgCrossplag.toFixed(2) >= 0 &&
                        thesis.avgCrossplag.toFixed(2) < 5,
                        'mediumAverage':
                        thesis.avgCrossplag.toFixed(2) >= 5 &&
                        thesis.avgCrossplag.toFixed(2) <= 20
                     }" class="bold">{{ thesis.avgCrossplag.toFixed(2) }}</span>
                     <span *ngIf="thesis.submissionsCount == 0">
                        -
                     </span>
                  </div>
               </div>
               <ng-container *ngIf="thesis.submissionsCount !== 0">
                  <a
                     class="blueText underline vold"
                     (click)="expand(thesis.thesisId)"
                     *ngIf="expandInfo != thesis.thesisId"
                     >{{ 'general.expand' | translate }}</a
                  >
                  <a
                     class="blueText underline vold"
                     (click)="expand(i)"
                     *ngIf="expandInfo == thesis.thesisId"
                     >{{ 'general.collapse' | translate }}</a
                  >
               </ng-container>
               <ng-container *ngIf="thesis.submissionsCount === 0">
                  <span> {{ 'app.no_submissions' | translate }} </span>
               </ng-container>
            </div>
            <div
               [ngClass]="{
                  expandedInfoSubmissions: expandInfo == thesis.thesisId
               }"
               class="moreInfoThesisSubmissions"
            >
               <table>
                  <tr>
                     <th>
                        <h5 class="bold left">
                           {{ 'general.table.name' | translate }}
                        </h5>
                     </th>
                     <th>
                        <h5 class="bold">
                           {{ 'general.date' | translate }}
                        </h5>
                     </th>
                     <th>
                        <h5 class="bold">{{ 'general.status' | translate }}</h5>
                     </th>
                     <th>
                        <h5 class="bold">
                           {{ 'general.table.number_of_words' | translate }}
                        </h5>
                     </th>
                     <th>
                        <h5 class="bold">
                           {{ 'general.language' | translate }}
                        </h5>
                     </th>
                     <th><h5 class="bold">{{ 'general.translated_language' | translate }}</h5></th>
                     <th><h5 class="bold">{{ 'report.ai_index' | translate }}</h5></th>
                     <th>
                        <h5 class="bold">
                           {{ 'general.table.similarity_report' | translate }}
                        </h5>
                     </th>
                  </tr>
                  <tr
                     *ngFor="
                        let submission of this.thesisSubmissions
                           ?.thesisSubmissionsDetails
                     "
                  >
                     <ng-container *ngIf="submission.showSubmission == true">
                        <td>
                           <h5 class="left">
                              <span
                                 *ngIf="submission.draftId !== null"
                                 style="font-weight: 700"
                                 >{{ 'general.table.draft' | translate }}:
                              </span>
                              {{ submission.title }}
                           </h5>
                        </td>
                        <td>
                           <h5>
                              {{ submission.createdAt | localTime }}
                           </h5>
                        </td>
                        <td>
                           <span *ngIf="submission.isPublic == 1">{{ 'general.checked' | translate }}</span>
                           <span *ngIf="submission.isPublic == 0"
                              >Not checked</span
                           >
                        </td>
                        <td>
                           <h5>{{ submission.wordCount }}</h5>
                        </td>
                        <td>
                           <h5
                              *ngIf="submission.processed == 1"
                              [ngClass]="{
                                 'red-border':
                                    submission.originalPercentage.toFixed(2) > 20,
                                 'green-border':
                                    submission.originalPercentage.toFixed(2) >=
                                       0 &&
                                    submission.originalPercentage.toFixed(2) < 5,
                                 'orange-border':
                                    submission.originalPercentage.toFixed(2) >=
                                       5 &&
                                    submission.originalPercentage.toFixed(2) <= 20
                              }"
                           >
                              <span *ngIf="submission.originalLanguage !== null"
                                 >{{ submission.originalLanguage | uppercase }}
                              </span>
                              <span *ngIf="submission.originalLanguage == null">
                                 --
                              </span>

                              {{ submission.originalPercentage.toFixed(2) }}%
                           </h5>
                           <h5
                              *ngIf="submission.processed == 2"
                              class="gray-border"
                           >
                              {{ 'app.suspended' | translate }}
                           </h5>
                           <h5
                              *ngIf="
                                 submission.processed == 0 ||
                                 submission.processed == -1
                              "
                              class="gray-border"
                           >
                              {{ 'report.processing' | translate }}
                           </h5>
                        </td>
                        <td>
                           <h5
                              *ngIf="submission.processed == 1"
                              [ngClass]="{
                                 'red-border':
                                    submission.translatedPercentage.toFixed(2) >
                                    20,

                                 'green-border':
                                    submission.translatedPercentage.toFixed(2) >=
                                       0 &&
                                    submission.translatedPercentage.toFixed(2) < 5,

                                 'orange-border':
                                    submission.translatedPercentage.toFixed(2) >=
                                       5 &&
                                    submission.translatedPercentage.toFixed(2) <=
                                       20,

                                 'gray-border':
                                    submission.translatedLanguage == null
                              }"
                           >
                              <span *ngIf="submission.translatedLanguage !== null"
                                 >{{ submission.translatedLanguage | uppercase }}
                              </span>
                              <span *ngIf="submission.translatedLanguage == null">
                                 --
                              </span>
                              <ng-container
                                 *ngIf="submission.translatedLanguage !== null"
                              >
                                 {{ submission.translatedPercentage.toFixed(2) }}%
                              </ng-container>

                              <ng-container
                                 *ngIf="submission.translatedLanguage == null"
                              >
                                 ---
                              </ng-container>
                           </h5>
                           <h5
                              *ngIf="
                                 submission.processed == 0 ||
                                 submission.processed == -1
                              "
                              class="gray-border"
                           >
                              {{ 'report.processing' | translate }}
                           </h5>
                        </td>
                                   <td>
                           <span
                              *ngIf="submission.processed == 1 && submission.aiDetection"
                              [ngClass]="{
                                 'red-border': submission.aiPercentage > 20,
                                 'green-border':
                                    submission.aiPercentage >= 0 &&
                                    submission.aiPercentage < 5,
                                 'orange-border':
                                    submission.aiPercentage >= 5 &&
                                    submission.aiPercentage <= 20
                              }"
                              ><span>{{ 'general.ai' | translate }}</span>
                              {{ submission.aiPercentage }}%</span
                           >
                           <h5
                              *ngIf="
                                 (submission.processed == 0 ||
                                 submission.processed == -1) && submission.aiDetection
                              "
                              class="gray-border"
                           > -
                           </h5>
                           <h5 *ngIf="submission.processed == 2 && submission.aiDetection" class="gray-border">
                              {{ 'app.suspended' | translate }}
                           </h5>
                           <h5 *ngIf="!submission.aiDetection" class="gray-border">
                              N/A
                           </h5>
                        </td>
                        <td>
                           <a
                              *ngIf="submission.processed == 1"
                              (click)="goToLink(submission.id)"
                              class="blue-btn reportBtn"
                              >{{ 'general.report' | translate }}</a
                           >

                           <a
                              *ngIf="
                                 submission.processed == 0 ||
                                 submission.processed == -1
                              "
                              (click)="
                                 showWarning('Document is still processing.')
                              "
                              class="disable-btn"
                              >{{ 'general.report' | translate }}</a
                           >
                           <a
                              *ngIf="submission.processed == 2"
                              (click)="showAlertMessage()"
                              class="yellow-btn"
                           >
                              <svg
                                 width="468"
                                 height="431"
                                 viewBox="0 0 468 431"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M406.65 122.69C405.98 111.19 392.44 102.39 364.73 94.95C365.5 93.01 365.96 90.95 366.08 88.86V41.51C363.38 2.26999 202.37 0.919983 183.43 0.919983C165.16 0.919983 3.48003 2.26999 0.780029 41.51V42.18V88.86C0.780029 101.71 17.69 111.86 42.05 119.3C42.05 120.65 41.38 121.33 41.38 122.68V123.35V170.03C15 176.8 1.47003 185.59 0.79003 197.09V197.76V244.44C0.79003 253.24 8.91003 260.68 21.75 267.44C21.2 268.72 20.97 270.11 21.08 271.5V272.17V318.85C21.08 341.17 71.81 355.38 127.99 362.14H130.02C140.84 363.49 151.67 364.17 162.49 364.84H163.84C177.37 365.51 191.58 366.19 203.75 366.19C215.92 366.19 230.13 365.52 243.66 364.84H245.01C255.83 364.17 266.66 363.49 277.48 362.14H279.51C335.66 355.37 386.42 341.84 386.42 318.85V271.5C385.75 263.38 378.98 256.62 364.77 250.54C365.54 248.6 366 246.54 366.12 244.45V200.48C390.47 193.04 406.71 182.87 406.71 170.04V122.67L406.65 122.69ZM393.12 123.36C392.45 128.1 382.3 134.18 363.35 139.6C339.67 147.04 301.79 153.81 254.43 155.84H193.55C146.18 153.81 108.31 147.04 84.63 139.6C66.36 134.19 55.54 128.1 54.86 123.36V122.69H56.21L64.33 124.72C78.85 127.79 93.53 130.05 108.3 131.49C119.12 132.84 130.62 133.52 142.12 134.19C150.24 134.86 159.03 134.86 167.15 135.54H193.53C242.92 134.87 288.24 128.77 320.03 119.98C321.38 119.31 322.73 119.31 324.09 118.63C324.76 118.63 326.12 117.96 326.79 117.96C329.19 117.48 331.48 116.56 333.56 115.26C334.23 115.26 334.23 115.26 334.91 114.59C336.75 114.03 338.56 113.35 340.32 112.56C340.83 112.49 341.31 112.25 341.67 111.89C343.7 111.22 345.05 109.86 347.08 109.19C347.75 108.52 348.43 108.52 349.11 107.84C349.78 107.16 350.46 107.17 351.81 106.49C352.48 106.49 352.48 105.82 353.16 105.82C384.32 113.22 392.44 120.66 393.12 123.36ZM184.08 14.45C295.7 14.45 351.85 32.06 353.2 42.19C352.53 46.93 341.7 53.01 323.43 58.43C299.75 65.87 261.87 72.64 214.51 74.67H153.63C106.26 72.64 68.39 65.87 44.72 58.43C26.45 53.02 15.63 46.93 14.95 42.19C15.63 32.04 72.44 14.45 184.08 14.45ZM47.41 182.89C56.88 192.36 76.5 199.8 100.18 205.21C100.85 205.21 101.53 205.21 101.53 205.88C103.56 206.55 104.91 206.55 106.94 207.23C132.12 212.47 157.69 215.64 183.38 216.7C192.85 217.37 201.65 217.37 211.79 218.05H238.17C246.97 218.05 255.78 217.38 264.55 216.7C290.71 215.38 316.72 211.99 342.35 206.55C335.89 209.96 329.09 212.68 322.05 214.67C297.02 222.79 256.43 229.55 205.02 230.91H152.28C104.91 228.88 67.04 222.11 43.36 214.67C24.42 209.26 14.27 202.51 13.59 198.43C15.62 195.05 22.39 188.96 47.42 182.88L47.41 182.89ZM372.8 272.19C372.13 276.93 361.98 283.01 343.03 288.43C319.35 295.87 281.47 302.64 234.11 304.67H173.25C125.88 302.64 88.01 295.87 64.34 288.43C46.73 283.02 35.93 276.93 34.57 272.19L40.66 274.22H41.33C43.04 274.99 44.87 275.44 46.74 275.57C47.41 275.57 48.09 276.24 48.77 276.24C50.12 276.24 50.8 276.91 52.15 276.91C81.7 283.85 111.81 288.15 142.12 289.76C152.94 290.43 163.08 290.43 173.91 291.11H194.21C204.36 291.11 213.83 290.44 223.3 289.76C234.8 289.09 246.3 287.73 257.12 287.06H257.79C269.95 285.71 281.47 283.68 291.61 281.65C293.64 280.98 295.67 280.98 298.38 280.3H299.73C316.9 277.37 333.54 271.9 349.1 264.07C349.77 263.4 350.45 263.4 351.13 262.72C351.8 262.04 352.48 262.05 353.16 261.37C353.84 260.69 354.51 260.7 355.19 260.02C368.73 266.11 372.79 270.85 372.79 272.2L372.8 272.19Z"
                                    fill="white"
                                 />
                                 <path
                                    d="M365.11 430.92C421.835 430.92 467.82 384.935 467.82 328.21C467.82 271.485 421.835 225.5 365.11 225.5C308.385 225.5 262.4 271.485 262.4 328.21C262.4 384.935 308.385 430.92 365.11 430.92Z"
                                    fill="#ECC332"
                                 />
                                 <path
                                    d="M365.1 430.92C308.46 430.92 262.39 384.85 262.39 328.21C262.39 271.57 308.47 225.5 365.1 225.5C421.74 225.5 467.81 271.57 467.81 328.21C467.81 384.85 421.74 430.92 365.1 430.92ZM365.1 259.04C326.96 259.04 295.93 290.07 295.93 328.21C295.93 366.35 326.96 397.38 365.1 397.38C403.24 397.38 434.27 366.35 434.27 328.21C434.27 290.07 403.25 259.04 365.1 259.04Z"
                                    fill="white"
                                 />
                                 <path
                                    d="M393.37 337.645H374.24V356.322H356.808V337.645H337.565V321.119H356.808V302.442H374.24V321.119H393.37V337.645Z"
                                    fill="white"
                                 />
                              </svg>
                              {{ 'general.add_credits' | translate }}
                              <div class="fas fa-info-circle tooltip">
                                 <div class="left">
                                    <p>
                                       You don't have enough credits.
                                       <br />{{ 'general.add_credits_to_process_the_file' | translate }}.
                                    </p>
                                 </div>
                              </div>
                           </a>
                        </td>
                     </ng-container>
                  </tr>
               </table>
            </div>
         </div>
         <pagination-controls
            *ngIf="this.thesisSubmissions?.thesisNumber != 0"
            class="num"
            (pageChange)="changePage($event)"
            responsive="true"
            previousLabel=""
            nextLabel=""
         ></pagination-controls>
      </div>
      <div
         class="zeroState"
         *ngIf="
            this.thesisSubmissions?.thesisNumber == 0 &&
            (level != '-1' ||
               facultyId != '-1' ||
               departmentId != '-1' ||
               professorId != '-1' ||
               studentName != undefined)
         "
      >
         {{ 'app.there_are_no_submissions' | translate }}
      </div>
      <div
         class="zero-state"
         *ngIf="
            this.thesisSubmissions?.thesisNumber == 0 &&
            level == '-1' &&
            facultyId == '-1' &&
            departmentId == '-1' &&
            professorId == '-1' &&
            studentName == undefined
         "
      >
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold" style="z-index: 1;">{{ 'app.there_are_no_theses_submitted' | translate }}.</h5>
      </div>
   </div>
</div>
